import { render, staticRenderFns } from "./Certificates.vue?vue&type=template&id=61c4385e&"
import script from "./Certificates.vue?vue&type=script&lang=js&"
export * from "./Certificates.vue?vue&type=script&lang=js&"
import style0 from "./Certificates.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Certificates.vue"
export default component.exports